import {
    red,
    volcano,
    orange,
    gold,
    yellow,
    lime,
    green,
    cyan,
    blue,
    geekblue,
    purple,
    magenta,
} from '@ant-design/colors';

const colors = [red, volcano, orange, gold, yellow, lime, green, cyan, blue, geekblue, purple, magenta];

export const EventSubTypeColorsList = colors.map((color) => [color[3], color[5], color[7], color[9]]);
export const EventSubTypeColorsListExtended = colors.map((color) => [
    color[1],
    color[2],
    color[3],
    color[4],
    color[5],
    color[6],
    color[7],
    color[8],
    color[9],
]);

export const FollowupColorsList = () => {
    const fu_colors = colors.map((color) => [color[1], color[3], color[5], color[7], color[8], color[9]]);
    fu_colors.unshift(['#f0f0f0', '#8c8c8c', '#434343', '#262626', '#1f1f1f', '#000000']);
    return fu_colors;
};
